/** POS 언어 */
export const PosLanguage = {
  En: 'ENG',
  Ko: 'KOR',
  Ja: 'JAP',
  Zh: 'CHI',
  Vi: 'VIE',
} as const;

export type PosLanguage = (typeof PosLanguage)[keyof typeof PosLanguage];
